// export const WP_URL = 'http://taqt.local/wp-json';
export const WP_URL = 'https://www.taqt-talent.nl/wp-json';

/*todo
metadata
*/


// WEBPACK FOOTER //
// ./src/wp-url.js